module.exports = __webpack_public_path__ + "static/media/rodape-logo-facebook.cca8038c.png";